import { GridCell, HeaderConfig } from "@urbannex/storethemes";
import { Page, PageType, Section, SelectOption, Site, SiteEditorConfig, SiteHeader } from "./editor-container/editor-model";

export interface InputField {
    name: string,
    title: string,
    type: string,
    controlType: string,
    value: any;
    context?: any;
    readonly?: boolean;
    selectOptions?: SelectOption[]
}
export interface LayoutState {
    pallette: string;
    screenWidth: number;
}


export enum EditState {
    LOADING = "loading",
    EDITING = "editing",
    UPDATED = "updated",
}


/* export interface SiteEditorConfigState{
    siteEditorConfig:SiteEditorConfig;
} */

/* export interface HeaderState {

}

export interface FooterState {

}

export interface NavigationState {

}

export interface HomePageState {

}

export interface CategoryPageState {

}

export interface CartState {

} */

export interface VisualEditorState {
    layoutState: LayoutState | null;
    siteEditorSitesState: Site[] | null;
    selectedSite: Site | undefined;
    headerState: HeaderConfig;
    selectedPageType: PageType | null;
    selectedSection: Section | null;
    selectedCell: GridCell | null;
    selectedPage: Page | null;
    editState: EditState | null;
    sectionEditState: EditState | null;
    pageEditState: EditState | null;
    hasUnsavedChanges?: boolean; // Track at store level
}


